export enum SiteNavNewEnum {
    SiteInformation =1,
    ContactInformation =2,
    BillingDetails =3,
    BillingContact =4
}